export default class UrlHelper {
    public static parseQueryString(queryString: string): { [s: string]: string } {
        const params: { [s: string]: string } = {};
        const queries = queryString.split("&");
        for (const query of queries) {
            const temp = query.split("=");
            if (temp.length === 2) {
                params[temp[0]] = temp[1];
            }
        }
        return params;
    }

    public static getUpdatedUrlWithParameter(url: string, paramKey: string, paramValue: string) {
        if (url === null || url.match(/^\s*$/) ||
            paramKey === null || paramKey.match(/^\s*$/) ||
            paramValue === null || paramValue.match(/^\s*$/)) {
            return url;
        }
        const startSign = url.indexOf("?") === -1 ? "?" : "&";
        const queryString = startSign + paramKey + "=" + paramValue;
        return url + queryString;
    }
}
